module.exports = __webpack_public_path__ + "static/img/del-hover.fce2a36.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/del-hover.png
// module id = cvJa
// module chunks = 103